import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarehouseProductQuantityHistoryReasonType } from '../../enums/warehouse-product-quantity-history-reason-type';
import { WarehouseProductQuantityHistoryReasonTypePipe } from '../../pipes/warehouse-product-quantity-history-reason-type.pipe';

@Component({
  selector: 'app-warehouse-product-quantity-history-reason-type',
  imports: [CommonModule, WarehouseProductQuantityHistoryReasonTypePipe],
  templateUrl:
    './warehouse-product-quantity-history-reason-type.component.html',
  styleUrl: './warehouse-product-quantity-history-reason-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseProductQuantityHistoryReasonTypeComponent {
  /* prettier-ignore */
  public readonly type = input.required<WarehouseProductQuantityHistoryReasonType>();

  protected readonly cssClass = computed(() => {
    switch (this.type()) {
      case WarehouseProductQuantityHistoryReasonType.ByReceipt:
        return 'text-blue-600';

      case WarehouseProductQuantityHistoryReasonType.NewGood:
        return 'text-green-600';

      case WarehouseProductQuantityHistoryReasonType.ByRelease:
        return 'text-emerald-700';

      case WarehouseProductQuantityHistoryReasonType.ByRestock:
        return 'text-indigo-600';

      case WarehouseProductQuantityHistoryReasonType.Manual:
        return 'text-fuchsia-600';

      default:
        return '';
    }
  });
}
